import React, { useCallback, useEffect, useState } from "react";
import { CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { errMessage } from "@/components/LoadError";

const tijd = (d) => d.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit", second: "2-digit" });

// v17-R1 D3: de systeemcheck draait bij openen één keer; "Opnieuw controleren" draait hem opnieuw.
export const Systeemcheck = () => {
  const [res, setRes] = useState(null);
  const [fout, setFout] = useState("");
  const [bezig, setBezig] = useState(false);
  const [om, setOm] = useState(null);
  const draai = useCallback(() => {
    setBezig(true); setFout("");
    api.get("/zelftest").then((r) => { setRes(r.data); setOm(new Date()); })
      .catch((e) => { setFout(errMessage(e)); setOm(new Date()); }).finally(() => setBezig(false));
  }, []);
  useEffect(() => { draai(); }, [draai]);
  return (
    <section data-testid="systeemcheck" className="bg-white border border-zinc-200 rounded-[10px] max-w-3xl">
      <header className="px-4 py-3 border-b border-zinc-200 flex flex-wrap items-center gap-3">
        <div className="flex-1 min-w-0">
          <h2 className="font-heading font-black text-zinc-900">Systeemcheck</h2>
          <p className="text-xs text-zinc-500">
            {res && <>Live versie <span data-testid="systeemcheck-versie" className="font-mono font-semibold text-zinc-800">{res.versie}</span> · </>}
            {om ? <span data-testid="systeemcheck-tijd">laatst gecontroleerd om {tijd(om)}</span> : "Bezig met controleren…"}
          </p>
        </div>
        {res && <span data-testid="systeemcheck-totaal" className={`text-xs font-bold uppercase tracking-wider rounded-full px-2.5 py-1 ${res.ok ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{res.ok ? "Alles werkt" : "Er is iets mis"}</span>}
        <button type="button" data-testid="systeemcheck-opnieuw" onClick={draai} disabled={bezig}
          className="min-h-[44px] inline-flex items-center gap-2 px-4 rounded-md border border-zinc-300 text-sm font-semibold hover:bg-zinc-50 disabled:opacity-50">
          <RefreshCw className={`h-4 w-4 ${bezig ? "animate-spin" : ""}`} />Opnieuw controleren
        </button>
      </header>
      {fout && <p data-testid="systeemcheck-fout" className="px-4 py-3 text-sm text-rose-700">De systeemcheck lukte niet: {fout}</p>}
      {res && (
        <ul className="divide-y divide-zinc-200">
          {res.checks.map((c) => (
            <li key={c.naam} data-testid={`systeemcheck-${c.naam}`} data-ok={c.ok ? "1" : "0"} className="px-4 py-2.5 flex items-start gap-3">
              {c.ok ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" /> : <XCircle className="h-5 w-5 text-rose-600 shrink-0" />}
              <span className="text-sm font-semibold text-zinc-800 w-28 shrink-0">{c.naam}</span>
              <span className={`text-sm ${c.ok ? "text-zinc-500" : "text-rose-700"}`}>{c.detail}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
